import * as _ from 'lodash';
import { SpinnerToggle } from '../../../../ng2/shared/constants/spinner.constant';
import { SessionStorageService } from './../../../../ng2/shared/services/web-storage/session-storage/session-storage.service';

// Set outside of class so that all instances share common status
let _isSpinning = false;

export class SpinnerModal {
  static $inject: string[] = ['$mdDialog', 'SessionStorageService'];

  msg: string;

  constructor(private $mdDialog: any, private sessionStorageService: SessionStorageService) {}

  activateSpinner(msg: string): any {
    if (_.isNull(this.sessionStorageService.getItem(SpinnerToggle.PREVENT_SPINNER))) {
      return;
    }

    if (_isSpinning) return;
    _isSpinning = true;

    this.$mdDialog.show({
      clickOutsideToClose: false,
      parent: document.body,
      template: require('./status-spinner.html'),
      controller() {
        this.msg = msg;
      },
      controllerAs: 'ctrl',
      locals: {
        msg,
      },
    });
  }

  deactivateSpinner(): void {
    if (_.isNull(this.sessionStorageService.getItem(SpinnerToggle.PREVENT_SPINNER))) {
      return;
    }

    _isSpinning = false;
    this.$mdDialog.hide();
  }
}
